import { isNullOrUndefined } from "../../common/utils";
import { InputFields } from "../condition/inputFields/userGroupInputFields";

export function inputFieldDataSync(
  changedAttributeName,
  changedValue,
  relatedValues,
  relatedAttributeName,
  inputFieldOptions
) {
  if (isNullOrUndefined(relatedAttributeName) || isNullOrUndefined(changedValue)) {
    return [];
  }
  const changedKey = InputFields[changedAttributeName].inputOptionsAttribute.key;
  const relatedKey = InputFields[relatedAttributeName].inputOptionsAttribute.key;
  const inputFieldKey = InputFields[changedAttributeName].inputOptionsAttribute.mainAttribute;

  let relatedAttributeOptions = [];
  let overallInputOptions = inputFieldOptions[inputFieldKey];

  overallInputOptions.forEach((option) => {
    const changedKeyValue = option[changedKey];
    let containsChangedValueFlag = false;
    if (Array.isArray(changedKeyValue)) {
      if (changedKeyValue.includes(changedValue)) {
        containsChangedValueFlag = true;
      }
    } else if (changedKeyValue === changedValue) {
      containsChangedValueFlag = true;
    }

    if (containsChangedValueFlag === true) {
      const relatedKeyValue = option[relatedKey];
      if (Array.isArray(relatedKeyValue)) {
        relatedKeyValue.forEach((relatedValue) => {
          relatedAttributeOptions.push(relatedValue);
        });
      } else {
        relatedAttributeOptions.push(relatedKeyValue);
      }
    }
  });

  relatedAttributeOptions = [...new Set(relatedAttributeOptions)];

  if (relatedAttributeOptions.length === 1) {
    relatedValues = [...relatedAttributeOptions];
  } else {
    const commonValues = relatedAttributeOptions.filter(x => relatedValues?.includes(x))
    if (commonValues?.length > 0)
      relatedValues = commonValues;
    else
      relatedValues = [];
  }
  return relatedValues;
}
